import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import ShrimpTransferRecord from '../ShrimpTransferRecord';

const ShrimpTransfer = () => {
    return (
        <Box sx={{ py: 3 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <ShrimpTransferRecord />
                </Grid>
            </Grid>
        </Box>
    )
}

export default ShrimpTransfer;
